<template>
  <div :class="$b()">
    <ContentLoop
      v-if="giftResponse.giftingPage.rows.length"
      :rows="giftResponse.giftingPage.rows"
      @click-giftcard="handleGiftCardClick"
    />

    <div class="global-wrapper">
      <GiftVoucherBlock ref="giftVoucherBlock" />
    </div>
  </div>
</template>

<script>
import query from '~/gql/gifting.gql.js'

export default defineNuxtComponent({
  name: 'GiftsPage',

  async setup() {
    definePageMeta({
      pageType: 'Gifts Page'
    })

    const { $head, $sentry, runWithContext } = useNuxtApp()
    const { data: giftResponse, error } = await useDatoQuery({
      query
    })

    if (error.value) {
      $sentry.captureException(error)
      createError({
        statusCode: error.value.statusCode,
        statusMessage: error.value.statusMessage,
      })
    }

    runWithContext(() => useHead($head(giftResponse.value.giftingPage.meta)))

    return { giftResponse }
  },

  mounted() {
    if (this.$route.query.scrollTo) {
      this.$scrollTo(`#${this.$route.query.scrollTo}`)

      this.$router.replace({
        query: {
          ...this.$route.query,
          scrollTo: null,
        },
      })
    }
  },

  methods: {
    handleGiftCardClick(value) {
      this.$refs.giftVoucherBlock.setValue(value)
    },
  },
})
</script>
